<template>
  <div>
    <div class="man-cell" style="margin: 10px">
      <el-input v-model="search" placeholder="媒体名称："></el-input>
    </div>
    <el-button style="margin: 10px" type="primary" @click="getMedia"
      >搜索</el-button
    >
    <el-button
      type="primary"
      @click="
        showDialog = true;
        edit = false;
        onRest();
      "
      >添加新媒体</el-button
    >
    <el-table
      :data="tableData"
      highlight-current-row
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column label="业务名称" prop="name"></el-table-column>
      <el-table-column label="所属平台" prop="portal"></el-table-column>
      <el-table-column label="业务类型" prop="channel"></el-table-column>
      <el-table-column label="工作时间" prop="others"></el-table-column>
      <el-table-column label="价格" prop="price"></el-table-column>
      <el-table-column label="备注" prop="remark" width="600px"></el-table-column>
      <el-table-column property="openid" label="编辑">
        <template slot-scope="scope">
          <el-button size="mini" @click="onEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="Pagination" style="text-align: left; margin-top: 10px">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="index"
        :page-size="20"
        layout="total, prev, pager, next"
        :total="count"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="!edit ? '添加百科' : '修改' + '百科'"
      :visible.sync="showDialog"
      width="50%"
    >
      <el-form ref="form" label-width="100px">
       <el-form-item label="业务名称：" style="width: 100%;">
          <el-input style="width: 100%" placeholder="填写物业名称，如：XX百科、XX下拉词、XX问答等等" size="small" v-model="name"></el-input>
        </el-form-item>
        <el-form-item label="知名门户：" style="width: 50%; float: left">
          <el-select v-model="portal3" placeholder="请选择">
            <el-option
              v-for="(item, index) in portal3List"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务类型：" style="width: 50%; float: left">
          <el-select v-model="channel3" placeholder="请选择">
            <el-option
              v-for="item in channel3List"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工作时间：" style="width: 50%; float: left">
          <el-select v-model="other3" placeholder="请选择">
            <el-option
              v-for="(item, index) in other3sList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格：" style="width: 50%; float: left">
          <el-input
            style="width: 80%"
            size="small"
            type="number"
            v-model="price3"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" style="width: 100%;float: left">
          <el-input type="textarea" style="width: 100%" placeholder="请填写业务介绍、执行周期、以及详细说明，如因未备注导致的纠纷我方有权根据情况给予客户直接退款、关闭订单等操作。" size="small" v-model="remark3"></el-input>
        </el-form-item>
        <el-form-item label="案例链接：" style="clear: both">
            <el-input
              style="width: 80%"
              type="textarea"
              size="small"
              v-model="mediaCase"
            ></el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="onChange">{{
          edit ? "确认修改" : "确认添加"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import myAxios from "../myAxios";
import areaJson from "../components/area.json";
export default {
  data() {
    return {
      count: 0,
      mediaId: "",
      size: 20,
      index: 1,
      tableData: [],
      loading: false,
      username: localStorage.getItem("username"),
      showDialog: false,
      search: "",
      portal3:"",
      name: "", //平台名称
      channel3: "其他", //业务类型
      price3: 0, //价格
      remark3: "", //备注
      edit: false,
      other3: "",
      areaList: [],
      channel3List: [
        { value: "其他", label: "其他" },
        { value: "企业百科", label: "企业百科" },
        { value: "人物百科", label: "人物百科" },
        { value: "品牌百科", label: "品牌百科" },
        { value: "网站百科", label: "网站百科" },
        { value: "产品百科", label: "产品百科" },
        { value: "软件APP百科", label: "软件APP百科" },
        { value: "一问一答", label: "一问一答" },
        { value: "一问多答", label: "一问多答" },
        { value: "下拉词", label: "下拉词" },
        { value: "发帖", label: "发帖" },
        { value: "盖楼", label: "盖楼" },
      ],
      boolList: [
        {
          value: true,
          label: "是",
        },
        {
          value: false,
          label: "否",
        },
      ],
      other3sList: [
        { value: "不限", label: "不限" },
        { value: "工作日", label: "工作日" },
        { value: "周六日", label: "周六日" },
        { value: "节假日", label: "节假日" },
        { value: "提前预约", label: "提前预约" },
      ],
      //
      readList: [
        {
          value: "1000以下",
          label: "1000以下",
        },
        {
          value: "1000-5000",
          label: "1000-5000",
        },
        {
          value: "5000-1万",
          label: "5000-1万",
        },
      ],
      portal3List: [
        { label: "百度", value: "百度" },
        { label: "360", value: "360" },
        { label: "搜狗", value: "搜狗" },
        { label: "知乎", value: "知乎" },
        { label: "新浪", value: "新浪" },
        { label: "天涯社区", value: "天涯社区" },
        { label: "soso", value: "soso" },
        { label: "悟空", value: "百悟空度" },
        { label: "其他", value: "其他" },
      ],
      fansList: [
        {
          value: "1万以下",
          label: "1万以下",
        },
        {
          value: "1万-5万",
          label: "1万-5万",
        },
        {
          value: "5万-10万",
          label: "5万-10万",
        },
      ],
    };
  },
  created() {
    this.getMedia();
  },
  computed: {},
  methods: {
    async getMedia() {
      myAxios
        .get(
          `/client_media/MyMedia/v1?username=${
            this.username
          }&name=${this.search.replace(/\s*/g, "")}&mediaType=5&index=${
            this.index
          }&size=${this.size}`
        )
        .then((res) => {
          this.tableData = res.data;
          this.count = res.total;
        });
      this.loading = false;
    },
    handleCurrentChange(val) {
      console.log(val);
      this.index = val;
      this.getMedia();
    },
    onEdit(index, row) {
      this.edit = true;
      this.mediaId = row.id;
      this.showDialog = true;
      this.name = row.name;
      this.price3 = row.price;
      this.channel3 = row.channel;
      this.remark3 = row.remark;
      this.portal3 = row.portal;
      this.other3 = row.other;
      this.mediaCase = row.mediaCase;
      // this.lanuch = row.lanuch.split("-");
    },
    onRest() {
      this.mediaId = "";
      this.name = "";
      this.price3 = 0;
      this.channel3 = "";
      this.remark3 = "";
      this.mediaCase=""
      // this.lanuch = row.lanuch.split("-");
    },
    onChange() {
      if (
        this.name == "" ||
        this.price3 == 0 ||
        this.channel3 == "" ||
        this.remark3 == ""
      ) {
        this.$alert("信息填写不全", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (this.price3 <= 0) {
        this.$alert("金额不小于0", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      var url = `/client_media/AddMedia/v1?username=${this.username}&area=不限&channel=${this.channel3}&contactable=true&included=不限&linkable=true&name=${this.name}&portal=${this.portal3}&price=${this.price3}&mediaType=5&remark=${this.remark3}&others=${this.other3}&mediaCase=${this.mediaCase}`;
      if (this.edit) {
        url = `/client_media/UpdateMedia/v1?mediaId=${this.mediaId}&username=${this.username}&area=不限&channel=${this.channel3}&contactable=true&included=不限&linkable=true&name=${this.name}&portal=${this.portal3}&price=${this.price3}&mediaType=5&remark=${this.remark3}&others=${this.other3}&mediaCase=${this.mediaCase}`;
      }
      myAxios.post(url).then((res) => {
        if (res.code == 0) {
          this.onRest();
          this.getMedia();
          this.showDialog = false;
          this.$message({
            type: "success",
            message: res.data,
          });
        }
      });
    },
  },
};
</script>

<style lang="less">
</style>
